/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_translate_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATG TTT TAA → M F * (a short open reading frame ending in a stop).`)
};

const es_translate_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATG TTT TAA → M F * (un marco de lectura abierto corto que termina en un codón de parada).`)
};

const de_translate_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATG TTT TAA → M F * (ein kurzer offener Leserahmen, der mit einem Stopp endet).`)
};

const nl_translate_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATG TTT TAA → M F * (een kort open leesframe eindigend op een stop).`)
};

const fr_translate_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATG TTT TAA → M F * (un court cadre de lecture ouvert se terminant par un stop).`)
};

const it_translate_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATG TTT TAA → M F * (una breve fase di lettura aperta che termina con uno stop).`)
};

const pt_br2_translate_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATG TTT TAA → M F * (uma fase de leitura aberta curta terminando em parada).`)
};

const pt_translate_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATG TTT TAA → M F * (uma grelha de leitura aberta curta que termina num codão de paragem).`)
};

const ja_translate_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATG TTT TAA → M F *（終止コドンで終わる短いオープンリーディングフレーム）。`)
};

const zh_translate_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATG TTT TAA → M F *（以终止子结尾的短开放阅读框）。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const translate_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.translate_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("translate_ex2", locale)
	if (locale === "en") return en_translate_ex2(inputs)
	if (locale === "es") return es_translate_ex2(inputs)
	if (locale === "de") return de_translate_ex2(inputs)
	if (locale === "nl") return nl_translate_ex2(inputs)
	if (locale === "fr") return fr_translate_ex2(inputs)
	if (locale === "it") return it_translate_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_translate_ex2(inputs)
	if (locale === "pt") return pt_translate_ex2(inputs)
	if (locale === "ja") return ja_translate_ex2(inputs)
	return zh_translate_ex2(inputs)
};